module.exports = __webpack_public_path__ + "img/only-bg.bc735f2c.svg";